import styled from 'styled-components';
import Panel from '@adsk/alloy-react-panel';

export const StyledPanelBody = styled(Panel.Body)`
  padding: 0 16px 16px 16px;
`;

export const FieldWrapper = styled.div`
  padding-top: 20px;
  width: 100%;
`;
